import i18next from 'i18next';
import moment from 'moment';
import 'moment/dist/locale/ro';
import 'moment/dist/locale/ru';
import PropTypes from 'prop-types';
import { createContext, useContext, useEffect, useMemo } from 'react';
import { DEFAULT_LANGUAGE } from 'utils/constants';

const LocaleContext = createContext();

export const useLocale = () => {
  const context = useContext(LocaleContext);
  if (!context) {
    throw new Error('useLocale must be used within a LocaleProvider');
  }
  return context;
};

export function LocaleProvider({ children }) {
  const changeLanguage = (languageCode) => {
    i18next.changeLanguage(languageCode);
    moment.locale(languageCode);
  };

  const currentLanguage = i18next.language || DEFAULT_LANGUAGE;

  useEffect(() => {
    moment.locale(currentLanguage);
  }, [currentLanguage]);

  const localeValue = useMemo(
    () => ({
      currentLanguage,
      changeLanguage,
    }),
    [currentLanguage],
  );

  return (
    <LocaleContext.Provider value={localeValue}>
      {children}
    </LocaleContext.Provider>
  );
}

LocaleProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
